// Export the Component Definition for use in Contentful Studio
export {TabGroupContentfulComponentDefinition} from './TabGroupContentfulDefinition';
export {default} from './TabGroup';
